import { UseTypedQueryOptions } from "api/UseTypedQueryOptions";
import { UseQueryResult, useQuery } from "react-query";

import { ValueChainReadDTO } from "../__generated__/CatalogueAPI";
import { CatalogueApiVersion, getValueChains, getValueChainsAll } from "../catalogApi";

type ValueChainAllReadDTO = Record<string, ValueChainReadDTO[]>;

export default function useValueChains(
  props?: UseTypedQueryOptions<ValueChainReadDTO[]>,
  apiVersion?: CatalogueApiVersion
): UseQueryResult<ValueChainReadDTO[]> {
  return useQuery(["valuechains", apiVersion], () => getValueChains(apiVersion), props);
}
export function useValueChainsAll(
  props?: UseTypedQueryOptions<ValueChainAllReadDTO>,
  apiVersion?: CatalogueApiVersion
): UseQueryResult<ValueChainAllReadDTO> {
  return useQuery(["valuechains-all", apiVersion], () => getValueChainsAll(apiVersion), props);
}
